import http from '@/requests/http'

class Notification {
  static getNotification (params) {
    return http.post('notifications', params)
  }

  static notify (params) {
    return http.post('notifications/notify', params)
  }
}

export default Notification
